var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTimeClockCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0Zm5.2 17.221a1.016 1.016 0 0 1-1.413.062l-4.959-4.546A1 1 0 0 1 10.5 12V6.5a1 1 0 0 1 2 0v5.06l4.634 4.248a1 1 0 0 1 .066 1.414Z"
})));
export { SvgTimeClockCircle as ReactComponent };
export default __webpack_public_path__ + "6f975654fc4685c318ec6372d5c12fe3fd10985afb1aeec9e47d50f860212849.svg";